// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AdvancedSearchPaneComponent } from '../advanced-search-pane/advanced-search-pane.component';
import { AdvancedSearchTableComponent } from '../advanced-search-table/advanced-search-table.component';
import { AdvancedSearchService } from '../../services/advanced-search.service';

@Component({
  selector: 'app-advanced-search',
  standalone: true,
  imports: [
    TranslateModule,
    AdvancedSearchPaneComponent,
    AdvancedSearchTableComponent
  ],
  templateUrl: './advanced-search.component.html',
  styleUrl: './advanced-search.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AdvancedSearchComponent implements OnDestroy {
  constructor(private advancedSeachService: AdvancedSearchService) {}

  ngOnDestroy(): void {
    this.advancedSeachService.cleanData();
  }
}
